import { motion } from 'framer-motion';
import { Clock, Users, UtensilsCrossed, Phone, Mail } from 'lucide-react';

interface ReservationsSidebarProps {
  t: any; // Translations object
}

const ReservationsSidebar = ({ t }: ReservationsSidebarProps) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, delay: 0.2 }}
      className="space-y-8"
    >
      {/* Opening Hours */}
      <div className="bg-white rounded-lg shadow-lg p-6">
        <div className="flex items-center gap-3 mb-4">
          <Clock className="text-red-800" size={24} />
          <h3 className="font-serif text-xl font-semibold text-neutral-900">
            {t.reservations.sidebar.hours.title}
          </h3>
        </div>
        <div className="space-y-2 text-neutral-700">
          <p>{t.reservations.sidebar.hours.weekdays}</p>
          <p>{t.reservations.sidebar.hours.sunday}</p>
        </div>
      </div>

      {/* Group Bookings */}
      <div className="bg-white rounded-lg shadow-lg p-6">
        <div className="flex items-center gap-3 mb-4">
          <Users className="text-red-800" size={24} />
          <h3 className="font-serif text-xl font-semibold text-neutral-900">
            {t.reservations.sidebar.groupBookings.title}
          </h3>
        </div>
        <p className="text-neutral-700 mb-4">{t.reservations.sidebar.groupBookings.description}</p>
        <div className="space-y-2">
          <a
            href="tel:+354-561-0500"
            data-umami-event="tel-click"
            data-umami-event-location="contact"
            className="flex items-center gap-2 text-red-800 hover:text-red-600 transition-colors"
          >
            <Phone size={16} />
            561 0500
          </a>
          <a
            href="mailto:larusg@simnet.is"
            data-umami-event="mailto-click"
            data-umami-event-location="contact"
            className="flex items-center gap-2 text-red-800 hover:text-red-600 transition-colors"
          >
            <Mail size={16} />
            larusg@simnet.is
          </a>
        </div>
      </div>

      {/* Reservation Policy */}
      <div className="bg-white rounded-lg shadow-lg p-6">
        <div className="flex items-center gap-3 mb-4">
          <UtensilsCrossed className="text-red-800" size={24} />
          <h3 className="font-serif text-xl font-semibold text-neutral-900">
            {t.reservations.sidebar.policy.title}
          </h3>
        </div>
        <div className="space-y-3 text-neutral-700 text-sm">
          {t.reservations.sidebar.policy.items.map((item: string, index: number) => (
            <p key={index}>• {item}</p>
          ))}
        </div>
      </div>
    </motion.div>
  );
};

export default ReservationsSidebar;
